import React, { useRef, useState, useEffect } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Grid} from '@mui/joy';
import ProgressBar from "./ProgressBar";
import { Button, Typography } from "@mui/material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles'
// import DoughnutChartWithSliders from "./DoughnutChartWithSliders";

const Answer = (props) => {
  const { setCurrentScreen, question, answers } = props
  const { Title, QuestionMarkers, ActualText, ActualColor, ScoreText, ScorePercentage, NextButton, ScorePercentageContainer, DescriptionText, LeftGrid } = styles;
  const maxNumber = Math.max(...(Object.values(answers)), ...(Object.values(question.actual)));
  let maxWidth = 80 / maxNumber; //slider length calculation.

  const calculatePercentage = () => {
    let answerPercentage = 0
    let keys = Object.keys(question.actual);
    let avgSliderValue = 100 / keys.length;
    for (let i = 0; i < keys.length; i++) {
      let difference = Math.abs(question.actual[keys[i]] - answers[keys[i]])
      answerPercentage += difference < 2 ? avgSliderValue : avgSliderValue - (difference - 1) >= 0 ? avgSliderValue - (difference - 1) : 0
      // difference = difference > 8 ? 0 : difference;
      // console.log("difference", difference)
      // answerPercentage += (8 - difference) * (avgSliderValue / 8);
    }
    return Math.round(answerPercentage);
  }
  return(
    <Grid container alignItems={'center'} justifyContent={'center'}>
      <LeftGrid container spacing={2} xs={12} justifyContent={'center'}>
        <Grid container xs={6} md={6}>
          <Title>
            {question.title}
            <Tooltip title="Source: Peter G. Peterson Foundation">
              <IconButton>
                <QuestionMarkers />
              </IconButton>
            </Tooltip>
          </Title>
          <Grid xs={12} container justifyContent={'center'}>
            <Grid xs={2}></Grid>
            <Grid container xs={3}>
              <ActualText >ACTUAL</ActualText>
              <ActualColor style={{ backgroundColor: "#003e4c" }} />
            </Grid>
            <Grid container xs={3}>
            <ActualText>GUESS</ActualText>
            <ActualColor style={{ backgroundColor: "#00b1d9" }} />
            </Grid>
            <Grid xs={4}></Grid>
          </Grid>

          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["IndividualIncome"]} guess={answers['IndividualIncome']} value={question.actual['IndividualIncome']} name={"Individual Income Tax"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["CorporateIncome"]} guess={answers['CorporateIncome']} value={question.actual['CorporateIncome']} name={"Corporate Income Tax"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["PayrollTax"]} guess={answers['PayrollTax']} value={question.actual['PayrollTax']} name={"Payroll Tax"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["CustomsDuties"]} guess={answers['CustomsDuties']} value={question.actual['CustomsDuties']} name={"Customs Duties"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["ExciseTax"]} guess={answers['ExciseTax']} value={question.actual['ExciseTax']} name={"Excise Tax"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Other"]} guess={answers['Other']} value={question.actual['Other']} name={"Other"} />
        </Grid>
        <Grid container xs={4} justifyContent={'center'} alignItems={'center'} style={{ flexDirection: 'column' }}>
          <Grid container xs={12} justifyContent={'center'} alignItems={'center'}>
            <ScoreText>YOUR SCORE</ScoreText>
            <ScorePercentageContainer container>
              <ScorePercentage>
              {calculatePercentage()}%
              </ScorePercentage>
            </ScorePercentageContainer>
            <DescriptionText>{question.description}</DescriptionText>
          </Grid>
        </Grid>
        <Grid container xs={1}></Grid>
      </LeftGrid>
      <NextButton

      onClick={() => setCurrentScreen("Question")}
       >RESTART</NextButton>
    </Grid>
  )
}

// Use it if you don't plan to use "remount"
// document.addEventListener('DOMContentLoaded', () => {
  // ReactDOM.render(, document.getElementById('hello'))
// })

export default Answer
